<template lang='pug'>
.login
	.circles
	.image
	.fid-logo
		img(src='/img/fid-logo.png' height='86' width='126')
		h1 Fresno Irrigation District
	#login-form
		.card-content
			Swiper.swiper(
				:options='formSwiperOptions'
				:active-slide='activeSlide'
				@swiper='swiper = $event'
				@slide-change-transition-end='updateActiveSlide'
			)
				.page.gradient(
					slot='slide-1'
				)
					LoginForm(
						@forgot='changeSlide'
						@user-update='user = $event'
						@error='showError( $event )'
						:user='user'
						slot='slide-1'
					)
				.page.forgot-password.gradient(
					slot='slide-2'
				)
					.go-back
						p(@click='exit') < BACK
					h2.title Enter Email
					p.subtitle Email
					.row
						input(type='email' v-model='user.email')
					a.link(@click='changeSlide(3)') {{ emailString }}
					.submit-wrapper
						a.button(@click='forgotPass') Submit
							.check-mark
				.page.forgot-email(
					slot='slide-3'
				)
					.go-back
						p(@click='exit') < BACK
					//- idk what the text for this is
					h2.title Contact Administrator To Review Email
					p Contact your administrator at johnsmith@fid.com to review your profile and reset/view your email address.
</template>

<script>
import { PasswordReset } from '@/lib/db/auth';

import Swiper from '@/components/Swiper';
import LoginForm from '@/components/LoginForm';

export default {

	name : 'login',

	data : () => ( {
		emailString : 'I don\'t know my email',

		user : {
			name  : null,
			email : null,
			uid   : null,
		},

		swiper : null,

		formSwiperOptions : {
			numberOfSlides : 3,

			config : {
				// auto initialize this swiper
				init         : true,
				initialSlide : 0,

				// swiper settings
				slidesPerView   : 'auto', // don't force all slides to be 100vw
				speed           : 400, // ms for when you let go of swipe
				spaceBetween    : 0, // no space between
				resistanceRatio : 0, // stops you from swiping past all slides
				direction       : 'horizontal',
				allowTouchMove  : ( window.innerWidth <= 667 ),

				threshold : 50, // min distance for scroll to work
			}
		},

		activeSlide : 0,

	} ),

	methods : {

		exit() {
			this.activeSlide = 0;
		},

		changeSlide( index ) {
			this.activeSlide = index;
		},

		updateActiveSlide() {
			const { activeIndex } = this.swiper;

			this.activeSlide = activeIndex;
		},

		forgotPass() {

			PasswordReset( this.user.email )
				.then( () => {
					// eslint-disable-next-line no-alert
					window.alert( 'Email has been sent.' );
				} )
				.catch( ( error ) => {
					console.error( error );
					// An error happened.
				} );

		},

	},

	components : {
		Swiper,
		LoginForm,
	}

};

</script>

<style lang='scss'>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/DEFAULT.scss';

.login {
	height: 100%;
	width: 100%;
	background: white;
	overflow: hidden;

	.circles {
		position: absolute;
		top: 0;
		left: 0;
		height: 560px * 0.8;
		width: 583px * 0.8;

		background: url('/img/login-circles.png');
		background-size: contain;
		background-position: left;
		background-repeat: no-repeat;
	}

	.image {
		position: absolute;
		bottom: 0;
		right: 0;
		height: 560px * 0.8;
		width: 583px * 0.8;

		background: url('/img/login-image.png');
		background-size: contain;
		background-position: right;
		background-repeat: no-repeat;
	}

	.fid-logo {
		position: absolute;
		top: 50px;
		right: 60px;
		width: 250px;

		img {
			float: right;
			margin-bottom: 40px;
		}

		h1 {
			color: $color-primary--variant-1;
			font-weight: 400;
			font-size: 40px;
			line-height: normal;
			text-align: right;
		}
	}

	.swiper {
		min-height: auto;

		.swiper-slide {
			min-height: auto;
		}
	}

	#login-form {
		background: white;
		box-shadow: $box-shadow__card;
		position: relative;
		border-radius: 30px;
		max-width: 450px;
		top: 45%;
		left: 420px;
		transform: translate( -50%, -50% );

		input {
			background: $input-bg;
			padding: 20px;
			font-weight: 500;
			font-size: 18px;
			color: $input-color;
			border-radius: 5px;
			height: 40px;
			width: 100%;
			padding: 0 20px;
		}

		.swiper {

			.swiper-container, .swiper-slide {
				min-height: auto;
				position: relative;
				overflow-x: hidden;
				height: auto;

				.page {
					overflow: hidden;
					height: 100%;
					min-height: fit-content;
					display: flex;
					flex-flow: column;
					color: $input-color;

					&.gradient {

						.submit-wrapper {
							position:relative;
							padding: 0;
							display: flex;
							justify-content: center;

							.button {
								position: relative;
							}

							&::after {
								content: '';
								position: absolute;
								top: 22.5px;
								left: -5%;
								background : linear-gradient(180deg, #F3F6FA, rgba(243, 246, 250, 0));
								width: 120%;
								height: 100%;
								z-index: -1;
							}
						}
					}

					.popup-error {
						top:-50%;
						transition:.5s ease-in-out;

						&.active{
							width: 100%;
							position: relative;
							padding: 15px;
							top: 0%;
							text-align: left;
							background: pink;
							z-index: 1;
							margin: 15px 0 15px 0;

							p {
								clear: both;
								position: relative;
								font-size: 16px;
								width: 100%;
								display: block;
								color: $error;
								margin: 0;
							}
						}
					}

					.go-back {
						padding: 20px;

						p {
							color: $color-primary;
							letter-spacing: 3px;
							font-size: 24px;
							float: left;
							&:hover {
								cursor: pointer;
							}
						}
					}

					&.forgot-password {

						.title, .subtitle, .row, .link {
							margin: 10px 40px;
						}

						.link {
							margin-left: auto;
							margin-right: auto;
							color: rgba(80, 96, 110, 0.67);
							cursor: pointer;
						}

						.submit-wrapper {
							margin-top: 25px;
						}
					}

					&.forgot-email {

						.title{
							padding: 20px;
						}

						> p {
							padding: 10px 20px;
						}
					}

					.login-form {
						padding: 0;

						.title, .row {
							margin: 10px 40px;
						}

						.title {
							margin-top: 45px;
						}

						.submit-wrapper {
							margin: 0;
							margin-bottom: 45px!important;
						}

						.forgot {
							color: rgba(80, 96, 110, 0.67);
							text-align: center;
							font-size: 14px;
							margin-bottom: 18px;

							span  {
								* {
									display: inline;
								}

								a {
									color: $input-color;
									border-bottom: 1px dashed black;
								}
							}
						}
					}

					.submit-wrapper {
						text-align: center;

						.button {
							margin-bottom: 45px;
						}
					}

					.button {
						border-radius: 30px;
					}
				}
			}
		}

	// 	.card-actions {
	// 		display: flex;
	// 		align-items: flex-start;
	// 		justify-content: center;
	// 		background: linear-gradient(180deg, #F3F6FA 0%, rgba(243, 246, 250, 0) 100%);
	// 		height: 77px + 35px;

	// 		.button {
	// 			border-radius: 25px;
	// 			font-weight: 500;
	// 			font-size: 14px;
	// 			letter-spacing: 0.03em;
	// 			padding: 13px 35px;
	// 		}
	// 	}

	// 	h2.title {
	// 		color: $color-primary;
	// 		font-style: normal;
	// 		font-weight: 500;
	// 		line-height: normal;
	// 		font-size: 36px;
	// 		margin-bottom: 12px;
	// 	}

	// 	&#login-form {
	// 		margin-top: 211px;
	// 		margin-left: 236px;
	// 		width: 466px;

	// 		.form-control {
	// 			justify-content: center;
	// 			display: flex;

	// 			label {
	// 				font-size: 14px;
	// 				margin-left: 10px;
	// 			}
	// 		}

	// 		#iforgot {
	// 			color: rgba(80, 96, 110, 0.67);
	// 			text-align: center;
	// 			font-size: 14px;
	// 			margin-bottom: 18px;

	// 			span  {
	// 				* {
	// 					display: inline;
	// 				}

	// 				a {
	// 					color: $input-color;
	// 					border-bottom: 1px dashed black;
	// 				}
	// 			}
	// 		}

	// 		.popup-error {
	// 			top:-50%;
	// 			transition:.5s ease-in-out;

	// 			&.active{
	// 				width: 100%;
	// 				position: relative;
	// 				padding: 15px;
	// 				top: 2.5%;
	// 				text-align: left;
	// 				background: pink;
	// 				z-index: 1;
	// 				margin: 15px 0 15px 0;

	// 				p {
	// 					clear: both;
	// 					position: relative;
	// 					font-size: 16px;
	// 					width: 100%;
	// 					display: block;
	// 					color: $error;
	// 					margin: 0;
	// 				}
	// 			}
	// 		}
	// 	}

	// 	label {
	// 		font-style: normal;
	// 		font-weight: 500;
	// 		line-height: normal;
	// 		font-size: 18px;
	// 		margin-bottom: 10px;
	// 	}

	// 	input[type='text'], input[type='email'], input[type='password'] {
	// 		background: $input-bg;
	// 		padding: 20px;
	// 		font-style: normal;
	// 		font-weight: 500;
	// 		line-height: normal;
	// 		font-size: 18px;
	// 		color: $input-color;
	// 		width: 100%;
	// 		margin-bottom: 20px;
	// 		border-radius: 10px;

	// 		&[name='password'] {
	// 			letter-spacing: 0.15em;
	// 		}
	// 	}
	}
}

@media screen and ( max-width: 980px ) {
	.login {
		.fid-logo {
			padding: 24px;
			position: relative;
			display: flex;
			width: 100%;
			top: unset;
			right: unset;
			justify-content: center;

			h1 {
				margin-left: 24px;
			}
		}

		.card#login-form {
			margin: 0 auto;
			margin-top: 5%;
		}
	}
}

@media screen and ( max-width: $mobile ) {
	.login {
		position: relative;
		overflow: unset;
		overflow-x: hidden;

		.fid-logo {
			img {
				height: 48px;
				width: 72px;
				margin-bottom: 12px;
			}

			margin-top: 12px;
			width: 100%;
			position: relative;
			display: block;
			top: 0;
			right: 0;
			display: flex;
			flex-direction: column;
			align-items: center;

			h1 {
				font-size: 24px;
				text-align: center;
			}
		}

		.card#login-form {
			margin-left: 0;
			margin-top: 0;
			width: calc(100% - 24px);
			margin: 12px;

			h2 {
				font-size: 24px;
			}
		}
	}
}
</style>
